import { useCallback, useContext } from 'react';
import { EditorContext } from '../../../../utils/contexts';

const DEFAULT_GAMIFICATION = {
  game_type: 'spin_wheel',
  one_play_per_visitor: true,
  rewards: [],
};

/**
 * Shared hook for reading and updating gamification settings.
 * Used by GamificationPanel and GamificationRewardsPanel to avoid
 * duplicating state management logic.
 */
export default function useGamification() {
  const { settings, updateSettings } = useContext(EditorContext);

  const gamification = settings.gamification || DEFAULT_GAMIFICATION;

  const updateGamification = useCallback(
    (updates) => {
      const merged = {
        ...gamification,
        ...updates,
      };
      if (merged.game_type === 'scratch_card') {
        merged.collect_email_before = true;
      }
updateSettings({
        gamification: merged,
      });
    },
    [gamification, updateSettings]
  );

  return { gamification, updateGamification, settings, updateSettings };
}
